/* eslint-disable import/no-anonymous-default-export */
export default {
  "hljs": {
    "display": "block",
    "overflowX": "auto",
    "padding": "0.5em",
    "background": "#573B2A",
    "color": "#F7E5AE"
  },
  "hljs-subst": {
    "color": "#3c3836"
  },
  "hljs-deletion": {
    "color": "#71C2A9"
  },
  "hljs-formula": {
    "color": "#71C2A9"
  },
  "hljs-keyword": {
    "color": "#71C2A9"
  },
  "hljs-link": {
    "color": "#71C2A9"
  },
  "hljs-selector-tag": {
    "color": "#71C2A9"
  },
  "hljs-built_in": {
    "color": "#DE731D"
  },
  "hljs-emphasis": {
    "color": "#DE731D",
    "fontStyle": "italic"
  },
  "hljs-name": {
    "color": "#DE731D"
  },
  "hljs-quote": {
    "color": "#DE731D"
  },
  "hljs-strong": {
    "color": "#DE731D",
    "fontWeight": "bold"
  },
  "hljs-title": {
    "color": "#DE731D"
  },
  "hljs-variable": {
    "color": "#DE731D"
  },
  "hljs-attr": {
    "color": "#71C2A9"
  },
  "hljs-params": {
    "color": "#71C2A9"
  },
  "hljs-template-tag": {
    "color": "#71C2A9"
  },
  "hljs-type": {
    "color": "#71C2A9"
  },
  "hljs-builtin-name": {
    "color": "#EC9C26"
  },
  "hljs-doctag": {
    "color": "#EC9C26"
  },
  "hljs-literal": {
    "color": "#EC9C26"
  },
  "hljs-number": {
    "color": "#EC9C26"
  },
  "hljs-code": {
    "color": "#EC9C26"
  },
  "hljs-meta": {
    "color": "#EC9C26"
  },
  "hljs-regexp": {
    "color": "#EC9C26"
  },
  "hljs-selector-id": {
    "color": "#EC9C26"
  },
  "hljs-template-variable": {
    "color": "#EC9C26"
  },
  "hljs-addition": {
    "color": "#F7E5AE"
  },
  "hljs-meta-string": {
    "color": "#F7E5AE"
  },
  "hljs-section": {
    "color": "#F7E5AE",
    "fontWeight": "bold"
  },
  "hljs-selector-attr": {
    "color": "#F7E5AE"
  },
  "hljs-selector-class": {
    "color": "#F7E5AE"
  },
  "hljs-string": {
    "color": "#F7E5AE"
  },
  "hljs-symbol": {
    "color": "#F7E5AE"
  },
  "hljs-attribute": {
    "color": "#DE731D"
  },
  "hljs-bullet": {
    "color": "#DE731D"
  },
  "hljs-class": {
    "color": "#DE731D"
  },
  "hljs-function": {
    "color": "#DE731D"
  },
  "hljs-function .hljs-keyword": {
    "color": "#DE731D"
  },
  "hljs-meta-keyword": {
    "color": "#DE731D"
  },
  "hljs-selector-pseudo": {
    "color": "#DE731D"
  },
  "hljs-tag": {
    "color": "#DE731D",
    "fontWeight": "bold"
  },
  "hljs-comment": {
    "color": "#fff",
    "fontStyle": "italic"
  },
  "hljs-link_label": {
    "color": "#EC9C26"
  }
};